import { Component, Input } from '@angular/core';
import { ApplicationAppEntityApplicationRead } from '../../../../../../../openapi';
import { LabelComponent } from '../../../../../../../common/label/label.component';
import { ShipmentContentLabelPipe } from '../../../../../../../pipes/shipment-content/shipment-content-label.pipe';

@Component({
  selector: 'app-irspa-letter-content-preview',
  standalone: true,
  imports: [
    LabelComponent,
    ShipmentContentLabelPipe
  ],
  templateUrl: './irspa-letter-content-preview.component.html'
})
export class IrspaLetterContentPreviewComponent {
  @Input()
  public application: ApplicationAppEntityApplicationRead | null = null;
}
